import { render, staticRenderFns } from "./First.vue?vue&type=template&id=7204c6d4&scoped=true"
import script from "./First.vue?vue&type=script&lang=js"
export * from "./First.vue?vue&type=script&lang=js"
import style0 from "./First.vue?vue&type=style&index=0&id=7204c6d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204c6d4",
  null
  
)

export default component.exports